var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-panel-properties-group',{attrs:{"title":"hola"}},[_c('p-panel-properties',[_c('p-property-tile',{attrs:{"title":"Example","icon":"mdi-cat"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }